export interface SellerProductSelection {
  sellerId: number | null;
  sellerProductIds: Set<number>;
}

export const emptySellerProductSelection = (): SellerProductSelection => ({
  sellerId: null,
  sellerProductIds: new Set(),
});

export const canSelectSellerProducts = (
  selection: SellerProductSelection,
  sellerId: number,
) => selection.sellerId === null || selection.sellerId === sellerId;

export const toggleSellerProductList = (
  expandedSellerId: number | null,
  sellerId: number,
) => (expandedSellerId === sellerId ? null : sellerId);

export const toggleSellerProductSelection = (
  selection: SellerProductSelection,
  sellerId: number,
  sellerProductId: number,
  selected: boolean,
): SellerProductSelection => {
  if (!canSelectSellerProducts(selection, sellerId)) return selection;

  const sellerProductIds = new Set(selection.sellerProductIds);
  if (selected) sellerProductIds.add(sellerProductId);
  else sellerProductIds.delete(sellerProductId);

  return {
    sellerId: sellerProductIds.size ? sellerId : null,
    sellerProductIds,
  };
};

export const setSellerProductSelection = (
  selection: SellerProductSelection,
  sellerId: number,
  sellerProductIds: number[],
  selected: boolean,
): SellerProductSelection => {
  if (!canSelectSellerProducts(selection, sellerId)) return selection;

  if (!selected) return emptySellerProductSelection();

  const selectedIds = new Set(sellerProductIds);
  return {
    sellerId: selectedIds.size ? sellerId : null,
    sellerProductIds: selectedIds,
  };
};
